import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { isAwaitingFiltration } from 'src/routes/SearchPage/searchStatus/selectors';

import {
  isVisibleShowMorePenalizedHotelsSelector,
  penalizedHotelsVisibleLimitSelector,
} from 'src/routes/SearchPage/store/emptyFiltration/selectors';
import { setPenalizedHotelsVisibleLimit } from 'src/routes/SearchPage/store/emptyFiltration/slices';
import { isVisibleShowMoreHotelsSelector } from 'src/routes/SearchPage/store/hotels/selectors';
import { ShowMoreHotels as ShowMoreHotelsComponent } from '../../../Hotels/components/ShowMoreHotels/ShowMoreHotels';

const mapStateToProps = (state) => ({
  hotelsVisibleLimit: penalizedHotelsVisibleLimitSelector(state),
  isVisible:
    isVisibleShowMorePenalizedHotelsSelector(state) &&
    !isVisibleShowMoreHotelsSelector(state),
  isAwaitingFiltration: isAwaitingFiltration(state),
});

const mapDispatchToProps = (dispatch) => ({
  setVisibleHotels: (count: number) =>
    dispatch(setPenalizedHotelsVisibleLimit(count)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(ShowMoreHotelsComponent);
